import React from "react";
import "../styles/nightlifeLanding.css";
import "../styles/nightlifeOnly.css";
import LandingShell from "./LandingShell";

export default function NightlifeLandingScreen() {
  const scenarios = {
    Nightlife: {
      src: "/assets/nightlife.mp4",
      poster: "/images/nightlife-poster.jpg",
      caption: "Nightlife: smoother flow, better vibes, fewer disruptions.",
    },
  };

  return (
    <LandingShell
      theme="nightlife"
      brandTag="Nightlife Partners"
      headlineTop="Upgrade Your"
      headlineAccent="Nightlife Bathroom Experience"
      subheadline={
        <>
          Built for <b>bars, clubs, and lounges</b>. Pay2Pee helps you manage peak-hour
          demand, reduce disruptions, and earn additional revenue — on your terms.
          <br /><br />
          <b>Built-in queueing helps prevent long lines</b> by controlling access during peak windows.
        </>
      }
      pills={[
        "Set your own rules",
        "Guests pay digitally",
        "Built-in queue prevents long lines",
      ]}
      scenarioLabel="Scenarios"
      scenarios={scenarios}
      stripItems={[
        { kicker: "Designed for peak hours", value: "Control access + flow" },
        { kicker: "Less disruption", value: "Staff stays focused" },
        { kicker: "More revenue", value: "Monetize demand" },
      ]}
      howSteps={[
        { icon: "⚙️", title: "Set your rules", text: "Choose hours, pricing, and access limits for your venue." },
        { icon: "🧾", title: "Queue + controlled access", text: "Our queue system helps manage demand and prevent long bathroom lines." },
        { icon: "💰", title: "Earn additional revenue", text: "Turn peak demand into consistent earnings—without chaos." },
      ]}
      benefits={[
        { title: "Shorter lines", text: "Queueing + controlled access keeps peak hours moving." },
        { title: "Cleaner bathrooms", text: "Controlled access reduces misuse and damage." },
        { title: "Less staff disruption", text: "Your team focuses on guests—not policing restrooms." },
        { title: "Premium guest experience", text: "A smoother system matches upscale nightlife expectations." },
      ]}
      ctaTitle="Become a Pay2Pee Nightlife Partner"
      ctaText="Drop your venue info and we’ll send partner details + next steps."
      ctaBullets={["Fast onboarding", "Set your rules", "Queue support + digital payments"]}
      primaryCtaText="Become a Partner"
      faq={[
        { q: "Do we control pricing and availability?", a: "Yes. You set your venue’s rules: hours, price, and access limits." },
        { q: "How does the queue work?", a: "During peak demand, guests join a controlled flow so access stays orderly and lines don’t explode." },
        { q: "Does this replace our restroom policy?", a: "No—it's an optional system you can use during busy windows." },
      ]}
    />
  );
}